module.exports = __webpack_public_path__ + "img/Freiburg.050185d3.png";